export enum ExperimentIds {
    // do not remove this is permanent exp for splitting users into segments
    SPLIT_INTO_TWO_SEGMENTS = "webtest_split_into_two_segments",
    FEMALE_PILATES_WEB_FUNNEL = "webtest_fempilates_feb24",
    USE_NEW_APPLE_PAY_FLOW = "webtest_new_apple_pay_flow_mar24",
    UPSELL_NUTRITION_BOOK = "webtest_upsell_bundle_scannutr",
    NEW_PAYMENT_VERSION = "webtest-palta-new-sdk-2",
    MALE_MUSCLE_GROUP_VISUALIZATION = "webtest_muscle_group_visualization_jun24",
    WTP_RESEARCH = "webtest_WTPresearch_jun24",
    DISABLE_PREVENT_DUPLICATE_FLOW = "disable_prevent_duplicate_flow",
    BODY_SCAN_AS_GIFT = "webtest_body_scan_as_gift_jun24",
    MALE_CALISTHENICS = "webtest_calisthenics_FAEX_495_jul24",
    REMOVE_UPGRADE_FLOW = "webtest_remove_upgrade_flow_jus24",
    OLD_MALE_FUNNEL = "webtest_old_male_funnel_jul24",
    BACKUP_SUB_PLUS_BC = "webtest_backup_sub_plus_BC_juj24",
    UX_PAYWALL_ABC_ITER1 = "webtest_UXpaywall_abc_iter1_FAEX_490_jul24",
    SQUARE_RADIO_BUTTONS = "webtest_radiobuttons_FAEX-499_jul24",
    WEIGHT_PREDICTOR_V3 = "webtest_weight_pred_iter3_FAEX_487_jul24",
    USER_SUMMARY = "webtest_user_summary_FAEX-496_jul24",
}

export const enum ExperimentVariants {
    CONTROL = "control",
    TEST = "test",
    TEST_1 = "test_1",
    TEST_2 = "test_2",
    TEST_3 = "test_3",
    NOT_ALLOCATED = "not_allocated",
    SEGMENT_A = "segment_A",
    SEGMENT_B = "segment_B",
}

export const TEST_VARIANTS = [
    ExperimentVariants.TEST,
    ExperimentVariants.TEST_1,
    ExperimentVariants.TEST_2,
    ExperimentVariants.TEST_3,
];
